module.exports = __webpack_public_path__ + "img/s3.517619b1.svg";